
import { Component, Vue } from 'nuxt-property-decorator'

@Component({ name: 'ChevronRightLight' })
export default class ChevronRightLight extends Vue {}
